export enum SearchTypeEnum {
    PROJECT,
    CAMERA,
    CAMERA_CCTV,
    USER,
    FILES,
    EXTERNAL_LINK,
}
